module.exports = __webpack_public_path__ + "img/download.6c2dc2df.png";